export default "__VITE_ASSET__Dk2hZ0VS__"